(() => {
  if (typeof window.customElements.get('collection-list-carousel') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'collection-list-carousel',
    class CollectionListCarousel extends HTMLElement {
      constructor() {
        super();

        this.carousel = this.querySelector('[data-collection-list-carousel-swiper]');
        this.cards = this.querySelectorAll('[data-collection-list-carousel-card]');
        this.boundHandleClickOutside = this.handleClickOutside.bind(this);

        this.initCollectionListCarousel();
      }

      initCollectionListCarousel() {
        try {
          this.setupSwiper();
          this.setupCards();
        } catch (error) {
          console.error('There was a problem with the CollectionListCarousel component:', error);
        }
      }

      setupSwiper() {
        if (!this.carousel) {
          return;
        }

        const prevButton = this.carousel.querySelector('[data-collection-list-carousel-prev]');
        const nextButton = this.carousel.querySelector('[data-collection-list-carousel-next]');
        const collectionSwiper = new Swiper(this.carousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
        });

        return collectionSwiper;
      }

      setupCards() {
        if (this.cards.length < 1) {
          return;
        }

        this.cards.forEach((card) => {
          card.addEventListener('click', (e) => {
            const anchor = e.target.closest('a');
            const isAnchor = e.target.tagName === 'A' || anchor !== null;

            if (isAnchor) {
              return;
            }

            e.preventDefault();

            if (card.classList.contains('active')) {
              card.classList.remove('active');
            } else {
              this.cards.forEach((card) => { card.classList.remove('active') });
              card.classList.add('active');
            }
          });
        });

        document.addEventListener('click', this.boundHandleClickOutside);
      }

      handleClickOutside(e) {
        const clickedInsideCard = Array.from(this.cards).some((card) => card.contains(e.target));
        if (!clickedInsideCard) {
          this.cards.forEach((card) => card.classList.remove('active'));
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.boundHandleClickOutside);
      }
    }
  );
})();
